import FeatureCollection from './YunyuFeatureCollection.js';

export default {
  title: 'Yunyu GeoJSON',
  oneOf: [
    FeatureCollection
  ]
};
